import { capitalize } from '@mui/material';
import { EDUCACION, SEXOS, VIVEN } from '../model/pacienteConstants';

export const convertirFecha = (fechaStr) => {
  const [anio, mes, dia] = fechaStr.split('-').map(Number);
  return new Date(anio, mes - 1, dia);
};

export const mapPacienteToFormData = (data) => ({
  codHistorico: data.codHistorico || '',
  firstname: data.firstname || '',
  lastname: data.lastname || '',
  telefono: data.telefono || '',
  dateBirth: data.dateBirth ? new Date(data.dateBirth).toISOString().split('T')[0] : '',
  grupo: data.grupo ?? '',
  sexo: Object.keys(SEXOS).find((key) => SEXOS[key] === data.sexo) || '',
  viven: Object.keys(VIVEN).find((key) => VIVEN[key] === data.viven) || '',
  nivelEducacional:
    Object.keys(EDUCACION).find((key) => EDUCACION[key] === data.nivelEducacional) || '',
  grupoREVI: !!data.grupoREVI,
  grupoEquilibrio: !!data.grupoEquilibrio,
  grupoSP: !!data.grupoSP,
  grupoVent: !!data.grupoVent,
});

export const mapFormDataToPayload = (formData) => ({
  ...formData,
  dateBirth: convertirFecha(formData.dateBirth),
  sexo: SEXOS[formData.sexo],
  viven: VIVEN[formData.viven],
  nivelEducacional: EDUCACION[formData.nivelEducacional],
  grupo: formData.grupo,
});

export const mapCuestionarioTipo = (tipo) => {
  switch (tipo) {
    case 'vent':
      return 'Vent';
    case 'sp':
    case 'incontinencia':
      return 'SP';
    case 'tesisTorres':
      return 'Tesis Torres';
    default:
      return capitalize(tipo);
  }
};

export const mapPacienteInformesToRows = ({ data, idPaciente }) => {
  const list = [];

  (data.capacidadesFuncionales || []).forEach((item) => list.push({
    id: item.codigo,
    tipo: 'SPPB y TUG',
    fecha: new Date(item.createdAt),
    pacienteId: idPaciente,
  }));

  (data.valoracionesFuncionales || []).forEach((item) => list.push({
    id: item.codigo,
    tipo: 'Fuerza Miembros Superiores',
    fecha: new Date(item.createdAt),
    pacienteId: idPaciente,
  }));

  (data.medidasAntropometricas || []).forEach((item) => list.push({
    id: item.codigo,
    tipo: 'Antropometria',
    fecha: new Date(item.createdAt),
    pacienteId: idPaciente,
  }));

  (data.encoder || []).forEach((item) => list.push({
    id: item.codigo,
    tipo: 'Encoder',
    fecha: new Date(item.createdAt),
    pacienteId: idPaciente,
  }));

  (data.cuestionario || []).forEach((item) => list.push({
    id: item.id,
    tipo: mapCuestionarioTipo(item.tipo),
    fecha: new Date(item.createdAt),
    pacienteId: idPaciente,
  }));

  return list
    .sort((a, b) => b.fecha - a.fecha)
    .map((row, index) => ({
      ...row,
      fecha: `${String(row.fecha.getDate()).padStart(2, '0')}/${String(row.fecha.getMonth() + 1).padStart(2, '0')}/${row.fecha.getFullYear()}`,
      rowId: `${row.tipo}-${row.id}-${index}`,
    }));
};

export const mapEntrevistasToRows = (entrevistas = [], idPaciente) =>
  [...entrevistas]
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    .map((entrevista) => ({
      id: entrevista.codigo,
      fecha: new Date(entrevista.createdAt).toLocaleDateString(),
      tipo: entrevista.tipoEntrevista || '',
      venredi: entrevista.venredi ? 'Pertenece' : 'No pertenece',
      terapiaOcupacional: entrevista.terapiaOcupacional ? 'Pertenece' : 'No pertenece',
      pacienteId: idPaciente,
    }));
